const ToggleSwitch = {

  /**
   * Create toggle switch component
   * @param {Node} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;
    this.options = props;

    this.node.addEventListener('change', (e) => {
      this.toggle(e.currentTarget.checked);
    });
  },

  toggle(checked) {
    const api = this.options.toggleSwitchApi;
    window.axios.post(api, {
      _method: 'PUT',
      checked,
    });
  },
};

export default ToggleSwitch;
